angular.module("staff")

    .controller("StaffListCtrl", ['LoginService', '$rootScope', '$scope', '$http', '$interval', '$q', 'i18nService', 'Restangular', 'gridService', '$filter', '$translate', 'modalService', '$uibModal','$state', 'datasetsService',
        function (LoginService, $rootScope, $scope, $http, $interval, $q, i18nService, Restangular, gridService, $filter, $translate, modalService, $uibModal,$state, datasetsService) {

        //Comprobamos si tiene permiso escritura
            $scope.allowWrite = LoginService.permissionExist("STAFF_WRITE");
        $rootScope.title = $filter('translate')('staff.title');
        $rootScope.breadcrumb = [
            { title: $filter('translate')('staff.title') }
        ];

        $scope.staff = {
            is_external: false
        };

        $scope.gridOptionsInternalStaff = {
            pdfTitle: $filter('translate')('staff.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            exporterSuppressColumns: ["image_id"], 
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    field: 'image_id',
                    enableSorting: false,
                    width: 40,
                    enableFiltering: false,
                    displayName: "",
                    cellTemplate: "<div style='height: 28px; overflow: hidden; text-align: center'><img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"/api/Image/GetImageBmp?id={{row.entity.image_id}}&maxW=28&maxH2=28\" style=\"margin-top:0px;border-radius:50%\" lazy-src></div>"
                },
              { name: 'puesto', field: 'FK_staff_staff_positions.name', displayName: $filter('translate')('staff.staff_position'), enableFiltering: true },
              { name: 'name', displayName: $filter('translate')('staff.name'), enableFiltering: true, enableHiding: false },
              { name: 'surname', displayName: $filter('translate')('staff.surname'), enableFiltering: true },
              { name: 'lastname', displayName: $filter('translate')('staff.lastname'), enableFiltering: true },
              { name: 'dni', displayName: $filter('translate')('staff.dni'), width: 100, enableFiltering: true },
              { name: 'email', displayName: $filter('translate')('staff.email'), enableFiltering: true },
              { name: 'phone', displayName: $filter('translate')('staff.phone'), width: 100, enableFiltering: true },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('staff.button_edit'), action: 'ui-sref="staff.edit({id:row.entity.id , is_external:false})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('staff.button_delete'), action: 'ng-click="grid.appScope.deleteInternalDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.is_external = false;
                return Restangular.all('Staff').getList(options);
            }
        };


        $scope.deleteInternalDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('staff.button_delete'),
                message: $filter('translate')('staff.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Staff', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('staff.delete_success'));
                        $scope.gridOptionsInternalStaff.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.gridOptionsExternalStaff = {
            pdfTitle: $filter('translate')('staff.pdf_title'),
            exporterMenuCsv: true,
            enableGridMenu: true,
            //gridMenuShowHideColumns: false,
            enableSorting: true,
            paginationPageSizes: [20, 40, 60],
            paginationPageSize: 20,
            rowTemplate: '<div ng-dblclick="grid.appScope.goToEdit(row.entity)" ng-repeat="(colRenderIndex, col) in colContainer.renderedColumns track by col.uid" class="ui-grid-cell" ng-class="col.colIndex()" ui-grid-cell style="cursor:pointer;"></div>',
            onRegisterApi: function (gridApi) {
                this.gridApi = gridApi;
            },
            columnDefs: [
                { name: 'id', visible: false, enableHiding: false, exporterSuppressExport: true },
                {
                    field: 'image_id',
                    enableSorting: false,
                    width: 40,
                    enableFiltering: false,
                    displayName: "",
                    cellTemplate: "<div style='height: 28px; overflow: hidden; text-align: center'><img width=\"28px\" ng-show=\"grid.getCellValue(row, col)\" ng-src=\"/api/Image/GetImageBmp?id={{row.entity.image_id}}&maxW=28&maxH2=28\" style=\"margin-top:0px;border-radius:50%\" lazy-src></div>"
                },
              { name: 'provider_name', displayName: $filter('translate')('staff.provider_name'), enableFiltering: true },
              { name: 'puesto', field: 'FK_staff_staff_positions.name', displayName: $filter('translate')('staff.staff_position'), enableFiltering: true },
              { name: 'name', displayName: $filter('translate')('staff.name'), enableFiltering: true, enableHiding: false },
              { name: 'surname', displayName: $filter('translate')('staff.surname'), enableFiltering: true },
              { name: 'lastname', displayName: $filter('translate')('staff.lastname'), enableFiltering: true },
              { name: 'dni', displayName: $filter('translate')('staff.dni'), width: 100, enableFiltering: true },
              { name: 'email', displayName: $filter('translate')('staff.email'), enableFiltering: true },
              { name: 'phone', displayName: $filter('translate')('staff.phone'), width: 100, enableFiltering: true },
              {
                  name: ' ', width: 150, exporterSuppressExport: true, enableSorting: false, enableHiding: false, enableFiltering: false, enableColumnMenu: false, cellTemplate: gridService.actionTemplate([
                      { title: $filter('translate')('staff.button_edit'), action: 'ui-sref="staff.edit({id:row.entity.id , is_external:true})"', cssIconClass: "fa fa-edit" },
                      { title: $filter('translate')('staff.button_delete'), action: 'ng-click="grid.appScope.deleteExternalDialog(row.entity.id,row.entity.name);" ng-if="grid.appScope.allowWrite"', cssIconClass: "fa fa-remove" }
                  ], { cssClass: "pull-right" })
              },
            ],
            getData: function (options) {
                options.is_external = true;
                return Restangular.all('Staff').getList(options);
            }
        };

        $scope.goToEdit = function (rowEntity) {
            $state.go("staff.edit", { id: rowEntity.id, is_external: $scope.staff.is_external });
        }



        $scope.deleteExternalDialog = function (id, name) {
            $scope.id = id;
            $scope.name = name;
            modalService.confirm({
                title: $filter('translate')('staff.button_delete'),
                message: $filter('translate')('staff.delete_message') + " " + $scope.name + "?",
                onAccept: function () {
                    Restangular.one('Staff', $scope.id).remove().then(function () {
                        toastr.success($filter('translate')('staff.delete_success'));
                        $scope.gridOptionsExternalStaff.gridApi.core.raise.itemDeleted($scope);

                    }, function (response) {
                        $scope.errorMessage = response.message;
                    });
                }
            });

        };

        $scope.export = function () {
            var options = {
                filters: {
                    IS_EXTERNAL: $scope.staff.is_external
                }
            };

            datasetsService.exportByType("staff", options);
        };

    }])

;